/* Product gallery 3D entry points (2026-10-09).
   "View in 3D" opens the 3D model slide. On a product with one model per size, only the
   model of the selected size is shown; this keeps that in step when the size changes. */
(function () {
  function handleize(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function init(gallery) {
    if (gallery.dataset.ch3dReady) return;
    gallery.dataset.ch3dReady = 'true';

    var actions = gallery.querySelector('[data-ch-3d-actions]');
    var list = gallery.querySelector('.product__media-list');
    if (!actions || !list) return;

    var sectionId = gallery.id.replace('MediaGallery-', '');
    var sizeStyle = document.getElementById('ChModelSize-' + sectionId);
    var viewButton = actions.querySelector('[data-ch-view-3d]');
    var wasIn3d = false;

    /* Which model belongs to the selected size. Not read from layout: in the desktop
       thumbnail layout every slide except the active one is display:none. */
    var sizeKey = sizeStyle ? (sizeStyle.textContent.match(/data-ch-model-size="([^"]+)"\]\)/) || [])[1] : null;

    function currentModelSlide() {
      var slides = Array.prototype.filter.call(list.querySelectorAll('li[data-media-id]'), function (slide) {
        return slide.querySelector('product-model');
      });
      var sized = slides.filter(function (slide) {
        return sizeKey && slide.dataset.chModelSize === sizeKey;
      });
      return sized[0] || slides[0];
    }

    function show3d() {
      var slide = currentModelSlide();
      if (slide && gallery.setActiveMedia) gallery.setActiveMedia(slide.dataset.mediaId, false);
    }

    if (viewButton) viewButton.addEventListener('click', show3d);

    if (!sizeStyle || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function () {
      var active = list.querySelector('li.is-active');
      wasIn3d = !!(active && active.querySelector('product-model'));
    });

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || data.sectionId !== sectionId || !data.variant) return;

      var key = handleize(data.variant.title);
      if (!list.querySelector('li[data-ch-model-size="' + key + '"]')) return;

      sizeKey = key;
      sizeStyle.textContent = '[data-ch-model-size]:not([data-ch-model-size="' + key + '"]){display:none!important}';
      ['viewer', 'thumbnails'].forEach(function (name) {
        var slider = gallery.elements && gallery.elements[name];
        if (slider && slider.resetPages) slider.resetPages();
      });

      if (wasIn3d) {
        wasIn3d = false;
        show3d();
      }
    });
  }

  function boot() {
    document.querySelectorAll('media-gallery').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
